import { Component,OnInit } from '@angular/core';
import { Router,NavigationEnd } from '@angular/router';

/**
 * @author Wesley Mascarenhas
 * @version $Id: footer.component.ts 79366 2018-02-17 00:40:37Z thiago.h.neri $
 */
@Component({
  selector: 'app-footer',
  templateUrl: './footer.html'
})
export class FooterComponent implements OnInit {

  private currentUrl: string;
   
  constructor(private router: Router) {

  }

  ngOnInit() {
    this.currentUrl = this.router.url;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
  };

  private isLoginURL() {
     return this.currentUrl === '/Portal/data' || this.currentUrl === '/Portal/data/login';
 }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/footer/footer.component.ts